import React from 'react';
import { observer } from 'mobx-react-lite';
import FilterIcon from '../FilterIcon';
import * as styles from '../Filter/Filter.scss';
import strings from '../../strings';

const OrdersIcon = ({ atiOrders, handleAtiOrdersClick }) => {
  const ordersImgUrlDefault = '/rating/assets/images/orders.svg';
  const ordersImgUrlSelected = '/rating/assets/images/orders-selected.svg';

  const ordersIcon = (
    <img
      alt="orders"
      className={styles.orders}
      src={ordersImgUrlDefault}
    />
  );

  const ordersIconSelected = (
    <img
      alt="orders-selected"
      className={styles.orders}
      src={ordersImgUrlSelected}
    />
  );

  const ordersText = strings.orders;

  return (
    <FilterIcon
      icon={ordersIcon}
      iconSelected={ordersIconSelected}
      text={ordersText}
      pressed={atiOrders}
      handleClick={handleAtiOrdersClick}
    />
  );
};

export default observer(OrdersIcon);
